module.exports = __webpack_public_path__ + "img/Creative.97a11a7a.svg";